<template>
  <Section :title="gettext('Type d’habitation')">
    <RadiosList
      :value="simulation.buildingType"
      :field="field"
      @change="(val) => updateSimulation({ buildingType: val.target.value })"
    >
      <template #default="slotProps">
        <div class="h5 mrgv0">{{ slotProps.choice[1] }}</div>
      </template>
    </RadiosList>
  </Section>
</template>

<script setup>
import Section from '@/components/simulation/Section.vue';
import RadiosList from '@/components/forms/fields/RadiosList.vue';
import { computed } from 'vue';
import { useSimulation } from '@/composables/useSimulation';

const { city, simulation, updateSimulation } = useSimulation();

const field = computed(() => {
  let choices = [
    ['standard', gettext('Appartement standard')],
    ['smallHouse', gettext('Petite villa, environ 100 m²')],
    ['mediumHouse', gettext('Villa moyenne, environ 150 m²')],
    ['largeHouse', gettext('Grande villa, environ 200 m²')],
    ['twinHouse', gettext('Maison jumelée')],
    ['building', gettext('Immeuble locatif')],
  ];

  if (
    simulation.buildingAltitude === 'high' ||
    (city.value && city.value.cityHeight > 1000)
  ) {
    choices = [
      ['standard', gettext('Appartement standard')],
      ['mediumHouse', gettext('Villa moyenne, environ 150 m²')],
      ['building', gettext('Immeuble locatif')],
    ];
  }

  return {
    label: gettext('De quel type de bâtiment s’agit-il?'),
    name: 'building-type',
    choices,
  };
});
</script>
